import React, {ButtonHTMLAttributes} from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

interface StyledButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  position: 'top' | 'bottom';
  top: number;
  bottom: number;
}

export const StyledButton = styled.button.attrs({
  className: 'd-flex p-2 btn-lg d-print-none',
})<StyledButtonProps>`
  z-index: 1000;
  position: fixed;
  right: 0;
  background: ${colors.linkBlue};
  color: #fff;
  border-radius: 4px 0 0 4px;
  border: none;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  ${({position, top, bottom}) =>
    position === 'top' ? 'top: ' + top + '%;' : 'bottom: ' + bottom + '%;'}

  &:hover {
    background: ${colors.lightLinkBlue};
  }
`;
type Props = {
  position: 'top' | 'bottom';
  deltaDistance?: number;
  showingDiagram: boolean;
  toggleDiagram: () => void;
  iconName: string;
};
export const ToggleDiagramButton = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      showingDiagram,
      toggleDiagram,
      position,
      iconName,
      deltaDistance = 0,
      ...other
    },
    ref
  ) => (
    <StyledButton
      onClick={toggleDiagram}
      position={position}
      top={40 + deltaDistance}
      bottom={10 + deltaDistance}
      ref={ref}
      {...other}
    >
      <i
        className={cs('fas fa-fw', showingDiagram ? 'fa-align-left' : iconName)}
      />
    </StyledButton>
  )
);
